<template>

  <div class="Rebate">
    <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-large
      rounded="sm"
      style="height:100vh"
      variant="dark"
      id="loader"
    >
    <b-row>
      <b-col cols="12 headerF"><HeaderFixed/></b-col>
      <b-col cols="12 headerM"><HeaderMobile/></b-col>
    </b-row>
      <b-container id="consBillDiv" fluid style="padding-top: 100px;text-align:left">

        <b-row>
          <b-col cols="12">
              <b-breadcrumb style=" background-color: #e9ecef78;">
                  <b-breadcrumb-item href="#home">
                    <router-link to="/">
                        <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                        Home
                    </router-link>
                  </b-breadcrumb-item>
                  <b-breadcrumb-item>
                <router-link to="/EodbReport">
                  EODB Report
                </router-link>
              </b-breadcrumb-item>
                 <b-breadcrumb-item href="#" active>Ownership Change/ Change of Name</b-breadcrumb-item>
              </b-breadcrumb>
            </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <span class="title">Ownership Change/ Change of Name</span>
          </b-col>
        </b-row>
        <hr/>
        <div class="paddingLeft30px">
           <br>
           <strong>In case of legal heir: </strong> Applicant should deposit processing fees along with relevant documents.
           <br><br>
           <strong>In case of property transfer: </strong> Applicant should deposit fresh load security amount along with processing fees and relevant documents.
     Note: Rs. 20 up to 4 kW and above 4kW Rs.10/ kW subject to max Rs.5,000
      <br>


      </div>
  </b-container>

<br><br>
</b-overlay>

  </div>

</template>


<script>

import HeaderFixed from '@/components/HeaderFixed.vue'
import HeaderMobile from '@/components/HeaderMobile.vue'
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.use(Vuex)
//const urlCommon = "http://localhost:8081/website";
//const urlCommon = "https://www.apdcl.org/website";
var consNo="";
var sdCode="";
var thColor = '#0288d1';
export default {
  name: 'PayBill',
  components: {

    'HeaderFixed' : HeaderFixed,
    'HeaderMobile' :HeaderMobile
    //MarqueeText

  },

  data() {
    return {

      reportFields: [
        { key: 'category', label: 'Category Type',thStyle: {width: '20vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'received', label: 'Applications Received',thStyle: {width: '20vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'granted', label: 'Connections Granted',thStyle: {width: '20vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'mean', label: 'Mean Time to Grant',thStyle: {width: '20vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'median', label: 'Median Time to Grant',thStyle: {width: '20vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
            ],
      report : [],

      show:false

    }
  },
  mounted() {
    var temp = [];
    var objDom;
    var objCom;
    var objInd, objOth;
    this.show= true;
    var parent = this;
    axios.get(this.$urlCommon+ "/api/web/nscReport")
    .then((response) => {
      parent.show= false;
      // console.log(response.data.nscReport);
      // return;
      var data = response.data.nscReport;
      var recDom = 0, recCom = 0, recInd = 0, recOth = 0;
      var grantDom = 0, grantCom = 0, grantInd = 0, grantOth = 0;
      var mean_43 = 0, mean_46 = 0, mean_47 = 0; //dom
      var mean_52 = 0, mean_53 = 0; //Industries
      var meanDom = 0, meanCom = 0, meanInd = 0, meanOth = 0;
      var medianDom = 0, medianCom = 0, medianInd = 0, medianOth = 0;
      var mean_49 =0, mean_50 = 0, mean_51 = 0, mean_54= 0, mean_55, mean_56, mean_57, mean_58, mean_59, mean_60; //Others
      var mean_61 =0, mean_62 = 0, mean_63 = 0, mean_64= 0, mean_65, mean_66, mean_67, mean_68, mean_69, mean_70; //Others
      var mean_72 =0, mean_74 = 0, mean_75 = 0, mean_77= 0; //Others
      data.forEach(element => {
        if(element[0]=='43' || element[0]=='46' || element[0]=='47'){
          if(element[0]=='43'){
            mean_43 = element[2]*element[3];
          }
          else if(element[0]=='46'){
            mean_46 = element[2]*element[3];
          }
          else if(element[0]=='47'){
            mean_47 = element[2]*element[3];
          }
          recDom = recDom + element[1];
          grantDom = grantDom + element[2];
          meanDom = (mean_43+mean_46+mean_47)/recDom;
          meanDom = Math.round(meanDom * 100) / 100;
          medianDom = medianDom + element[4];
          // obj = {
          //   "category" : "Domestic",
          //   "received" :  rec+" Nos.",
          //   "granted" :  grant+" Nos.",
          //   "mean" : mean+" Days",
          //   "median" : median+" Days",
          //   // "category" : element[0],
          //   // "received" :  element[1]+" Nos.",
          //   // "granted" :  element[2]+" Nos.",
          //   // "mean" : element[3]+" Days",
          //   // "median" : element[4]+" Days",
          //   }
          //   // temp.push(obj);
          //   // parent.report = temp;
        }
        else if(element[0]=='48'){
          recCom = element[1];
          grantCom = element[2];
          meanCom = element[3];
          medianCom = element[4];
        }
        else if(element[0]=='52' || element[0]=='53'){
          if(element[0]=='52'){
            mean_52 = element[2]*element[3];
          }
          else if(element[0]=='53'){
            mean_53 = element[2]*element[3];
          }

          recInd = recInd + element[1];
          grantInd = grantInd + element[2];
          meanInd = (mean_52+mean_53)/recInd;
          meanInd = Math.round(meanInd * 100) / 100;
          medianInd = medianInd + element[4];
          console.log(medianInd);
        }
        else{
          if(element[0]=='49'){
            mean_49 = element[2]*element[3];
          }
          else if (element[0]=='50'){
            mean_50 = element[2]*element[3];
          }
          else if (element[0]=='51'){
            mean_51 = element[2]*element[3];
          }
          else if (element[0]=='54'){
            mean_54 = element[2]*element[3];
          }
          else if (element[0]=='55'){
            mean_55 = element[2]*element[3];
          }
          else if (element[0]=='56'){
            mean_56 = element[2]*element[3];
          }
          else if (element[0]=='57'){
            mean_57 = element[2]*element[3];
          }
          else if (element[0]=='58'){
            mean_58 = element[2]*element[3];
          }
          else if (element[0]=='59'){
            mean_59 = element[2]*element[3];
          }
          else if (element[0]=='60'){
            mean_60 = element[2]*element[3];
          }
          else if (element[0]=='61'){
            mean_61 = element[2]*element[3];
          }
          else if (element[0]=='62'){
            mean_62 = element[2]*element[3];
          }
          else if (element[0]=='63'){
            mean_63 = element[2]*element[3];
          }
          else if (element[0]=='64'){
            mean_64 = element[2]*element[3];
          }
          else if (element[0]=='65'){
            mean_65 = element[2]*element[3];
          }
          else if (element[0]=='66'){
            mean_66 = element[2]*element[3];
          }
          else if (element[0]=='67'){
            mean_67 = element[2]*element[3];
          }
          else if (element[0]=='68'){
            mean_68 = element[2]*element[3];
          }
          else if (element[0]=='69'){
            mean_69 = element[2]*element[3];
          }
          else if (element[0]=='70'){
            mean_70 = element[2]*element[3];
          }
          else if (element[0]=='72'){
            mean_72 = element[2]*element[3];
          }
          else if (element[0]=='74'){
            mean_74 = element[2]*element[3];
          }
          else if (element[0]=='75'){
            mean_75 = element[2]*element[3];
          }
          else if (element[0]=='77'){
            mean_77 = element[2]*element[3];
          }
          recOth = recOth + element[1];
          grantOth = grantOth + element[2];
          meanOth = (mean_49+mean_50+mean_51+mean_54+mean_55+mean_56+mean_57+mean_58+mean_59+mean_60+mean_61+mean_62+mean_63+mean_64+mean_65+mean_66+mean_67+mean_68+mean_69+mean_70+mean_72+mean_74+mean_75+mean_77)/recOth;
          meanOth = Math.round(meanOth * 100) / 100;
          medianOth = medianOth + element[4];
        }
      });
      medianDom=medianDom/3;
      medianDom = Math.round(medianDom * 100) / 100;
      medianInd=medianInd/2;
      medianInd = Math.round(medianInd * 100) / 100;
      medianOth=medianOth/24;
      medianOth = Math.round(medianOth * 100) / 100;
      data.forEach(element =>{
        objDom = {
          "category" : "Domestic",
          "received" :  recDom+" Nos.",
          "granted" :  grantDom+" Nos.",
          "mean" : meanDom+" Days",
          "median" : medianDom+" Days"
          // "category" : element[0],
          // "received" :  element[1]+" Nos.",
          // "granted" :  element[2]+" Nos.",
          // "mean" : element[3]+" Days",
          // "median" : element[4]+" Days",
          }
          objCom = {
            "category" : "Commercial",
            "received" :  recCom+" Nos.",
            "granted" :  grantCom+" Nos.",
            "mean" : meanCom+" Days",
            "median" : medianCom+" Days"
          }
          objInd = {
            "category" : "Industries",
            "received" :  recInd+" Nos.",
            "granted" :  grantInd+" Nos.",
            "mean" : meanInd+" Days",
            "median" : medianInd+" Days"
          }
          objOth = {
            "category" : "Others",
            "received" :  recOth+" Nos.",
            "granted" :  grantOth+" Nos.",
            "mean" : meanOth+" Days",
            "median" : medianOth+" Days"
          }
      });


      temp.push(objDom);
      temp.push(objCom);
      temp.push(objInd);
      temp.push(objOth);
      parent.report = temp;
      // var obj = {
      //   "category" : data[0][0],
      //   "received" :  data[0][1]+" Nos.",
      //   "granted" :  data[0][2]+" Nos.",
      //   "mean" : data[0][3]+" Days",
      //   "median" : data[0][4]+" Days",
      //
      //   }
         // temp.push(obj);
         // parent.report = temp;
        // document.getElementById("date").innerHTML=data[0][5];
    })

  }
}
//background-image: url('../assets/bg.jpg');background-color: #82828226;

</script>

<style scoped="true">

/deep/ .table > tbody > tr > td {
font-size: 1.2rem;
  font-weight: 600;
  color: #dd2c00  ;
}
.title {
  color: #1976d2;
  font-size: 1.5rem;
  font-weight: 600;
  text-transform: none !important;
}
.paddingRow{
  padding:0.7rem;
}
.paddingCol{
  padding: none;
}
.label{
font-weight: 600;
}
.data{
  font-weight: 600;
  color: #ff5722         ;
  font-size: 1.5rem;
}
.hideDetails
{
   visibility: hidden;
  opacity: 0;
  transition:visibility 0s, opacity 0.5s linear;
  box-shadow: 2px 2px 10px 2px #bdbdbd;
  padding: 1rem;
  margin-right: 1.5rem;
}
.showDetails
{

  visibility: visible;
 opacity: 1;
}
hr {
   margin-top: 5px;
   margin-bottom: 5px;
  }
.go:focus{
  box-shadow: none;
}

.headerF{
  display: block;
}
.headerM{
  display: none;
}

.paddingLeft30px{
  padding-left: 30px;
}

@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
    .paddingLeft30px{
      padding-left: 0px;
    }
  }
@media only screen and (max-width: 414px) {
  .paddingCol{
    padding: 0.7rem;
  }
  .paddingRow{
    padding: none !important;
  }
  .paddingLeft30px{
    padding-left: 0px;
  }
}


</style>
